const getViewportWidth = () => {
	return document.querySelector('html').clientWidth;
};

const setDecorativeMaxWidth = () => {
	decorativeElements.forEach((el) => {
		const enclosingSectionRect = el.closest('section').getBoundingClientRect();
		el.style.setProperty('--max-width', `${(getViewportWidth() - enclosingSectionRect.width) / 2}px`);
	});
};

const decorativeElements = document.querySelectorAll('.decorative-element');
if (decorativeElements.length) {
	setDecorativeMaxWidth();
	window.addEventListener('resize', setDecorativeMaxWidth);
}
